import type { SiblingItem } from '../types/nav';

/**
 * SF-150: single source of truth for which pages belong to the Kingdom Part, consumed by both
 * `KingdomHub` and `SiblingRow`. Mirrors Sidebar.tsx's (updated) Kingdom section item-for-item
 * (same routes, same icon paths, same pillar assignments) — reuses that taxonomy rather than
 * inventing a new one, following `REALM_ITEMS`/`WAR_ITEMS`'s existing precedent (full taxonomy
 * unification explicitly deferred).
 *
 * `key: 'roster'` / `label: 'My Kingdom'` is an intentional split, not an inconsistency — the key
 * matches the destination page's identity (`Kingdom.tsx`, `/kingdom/roster`) while the label
 * matches sidebarNav.ts and the desktop Sidebar entry, mirroring `WAR_ITEMS`'s
 * `key: 'thievery'` / `label: 'Thievery'` precedent.
 */
export const KINGDOM_ITEMS: readonly SiblingItem[] = [
  { key: 'roster',   label: 'My Kingdom', route: '/kingdom/roster',   pillar: 'neutral', iconPath: 'M3 5H13M8 5V14M4 8H12M5 11H11' },
  { key: 'politics', label: 'Politics',    route: '/kingdom/politics', pillar: 'neutral', iconPath: 'M8 2L2 6H14ZM4 7V12H6V7M10 7V12H12V7M3 12H13V14H3Z' },
  { key: 'dragons',  label: 'Dragons',     route: '/kingdom/dragons',  pillar: 'neutral', iconPath: 'M4 8C4 4 8 2 8 2S12 4 12 8L10 10L12 13H4L6 10ZM7 6H9' },
  { key: 'aid',      label: 'Aid',         route: '/kingdom/aid',      pillar: 'neutral', iconPath: 'M8 4V12M4 8H12' },
];
